import angular from 'angular';
import { isEmpty } from 'lodash';

module.exports = angular.module('common.filters.any', [])
.filter('any', function() {
  return function(input) {
    return !isEmpty(input);
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/any.js
 **/